import { Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { escapeRegex } from '@app/utils/helpers/escape-regex.helper';

@Directive({
  selector: '[appHighlight]',
  standalone: true,
})
export class HighlightDirective {
  public text = input.required<string>();
  public query = input.required<string>();
  public highlightClass = input.required<string>();

  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  constructor() {
    effect(() => {
      const fullText = this.text().toLowerCase();
      const queryStr = this.query().toLowerCase();

      if (queryStr.trim() && fullText.includes(queryStr)) {
        this.highlight();
      } else {
        this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', this.text());
      }
    });
  }

  private highlight(): void {
    const queryStr = this.query().toLowerCase();
    const words = this.text().split(new RegExp(`(${escapeRegex(queryStr)})`, 'gi'));

    this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', '');

    words.forEach((word) => {
      if (word.toLowerCase() === queryStr) {
        const span = this.renderer.createElement('span');

        this.renderer.addClass(span, this.highlightClass());
        this.renderer.appendChild(span, this.renderer.createText(word));
        this.renderer.appendChild(this.elementRef.nativeElement, span);
      } else {
        this.renderer.appendChild(this.elementRef.nativeElement, this.renderer.createText(word));
      }
    });
  }
}
